interface IGTagFunc {
  (): void;
  (type: string, date: Date): void;
  (type: string, id: string): void;
  (eventType: string, eventName: string, payload: Record<string, unknown>): void;
}

interface IWindowWithGtag extends Window {
  gtag?: IGTagFunc;
}

class ServiceGTag {
  private config?: Record<any, any>;

  constructor(config?: Record<any, any>) {
    this.config = config;
  }

  send = (event: string, label: string, payload: Record<string, any> = {}): Promise<void> => {
    if (typeof window === 'undefined' || typeof (window as IWindowWithGtag).gtag !== 'function') {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      try {
        // @ts-ignore
        (window as IWindowWithGtag).gtag('event', event, {
          event_label: label,
          event_category: 'WebPlayer',
          event_callback: () => {
            resolve();
          },
        });
      } catch (error) {
        reject(error);
      }
    });
  };
}

export default ServiceGTag;
